import {
  AIAssistantMessageType,
  ParsedConversation,
  RawMessage
} from 'services/hooks/ai-assistant-service';
import {
  AI_CHAT_ASSISTANT,
  AIAssistantMessageDirection,
  AIAssistantMessagePosition,
  CHAT_USER
} from './constants';

/**
 * Parse an encoded JSON string into an array of RawMessage objects.
 */
export const parseConversation = (encodedStr: string): ParsedConversation | null => {
  try {
    const parsedConversation: ParsedConversation = JSON.parse(encodedStr);

    return parsedConversation;
  } catch (error) {
    console.error('Failed to parse conversation:', error);
    return null;
  }
};

export function transformRawMessage(
  msg: RawMessage,
  position?: AIAssistantMessagePosition
): AIAssistantMessageType {
  return {
    sender: msg.author === CHAT_USER ? CHAT_USER : AI_CHAT_ASSISTANT,
    message: msg.message,
    direction:
      msg.author === CHAT_USER
        ? AIAssistantMessageDirection.Outgoing
        : AIAssistantMessageDirection.Incoming,
    position: position || AIAssistantMessagePosition.Normal,
    timestamp: msg.timestamp
  };
}
